import { render } from "./FieldDate.vue?vue&type=template&id=0f4d5eac&scoped=true&ts=true&lang=pug"
import script from "./FieldDate.vue?vue&type=script&lang=ts"
export * from "./FieldDate.vue?vue&type=script&lang=ts"

import "./FieldDate.vue?vue&type=style&index=0&id=0f4d5eac&scoped=true&lang=css"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4d5eac"]])

export default __exports__